import { createUseStyles } from '@pe-libs/react-components/build/theme';

type PropsType = {
  fontSize: { desktop: string; mobile: string };
};

const useStyles = createUseStyles(
  'default-landing',
  ({
    typography,
    palette: { common, secondary },
    breakpoints: {
      up,
      values: { lg },
    },
  }) => ({
    container: {
      maxWidth: `${lg}px`,
    },
    contentWrapper: {
      composes: '$container',
      padding: '9rem 1rem 2.5rem',
      margin: '0 auto',
      textAlign: 'center',

      [up(392)]: {
        padding: '6.5rem 1rem 2.5rem',
      },

      [up(674)]: {
        padding: '4.5rem 3.75rem 4rem',
      },
    },
    profileDesc: {
      fontSize: ({ fontSize }: PropsType) => fontSize.mobile,
      lineHeight: 1.5,
      letterSpacing: '0.15px',
      marginBottom: '0.6em',
      [up('sm')]: {
        fontSize: ({ fontSize }: PropsType) => fontSize.desktop,
      },
    },
    profileTitle: {
      composes: '$profileDesc',
      fontWeight: typography.fontWeightSemiBold,
      marginTop: '2.5rem',
      fontSize: '2.125rem',
      [up('lg')]: {
        marginTop: '4rem',
      },
      '& svg': {
        fontSize: '24px',
        marginLeft: '12px',
      },
    },
    socialTitle: {
      composes: '$profileDesc',
      margin: '2.25rem 0 1rem',
      fontSize: '1rem',
      [up('md')]: {
        fontSize: '1.125rem',
      },
    },
    goldBackground: {
      backgroundColor: secondary.main,
    },
    contentContainer: {
      composes: '$container',
      color: common.white,
      margin: '0 auto',
      padding: '2rem 1rem',

      [up('md')]: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '4rem 3.75rem 4rem',
      },
    },
    profileAboutContainer: {
      maxWidth: '36.875rem',

      [up('md')]: {
        paddingRight: '1.5rem',
      },
    },
    profileAbout: {
      fontSize: '1rem',
      marginTop: '1.8rem',
      '& > p': {
        [up('sm')]: {
          fontSize: '1.125rem',
          lineHeight: 1.5,
        },
      },
    },
    formInfo: {
      margin: '2.5rem 0 1.5rem 0',
      textAlign: 'center',
      [up('sm')]: {
        textAlign: 'left',
      },
    },
  }),
);

export default useStyles;
